import React from 'react';
import { conditionClassModifier } from '@surfline/web-common';
import classNames from 'classnames/bind';
import type { RatingHour } from 'types/conditionRating';
import styles from './ConditionRatingsBar.module.scss';

const cx = classNames.bind(styles);
const getConditionsClassName = (className: string, conditions: string) =>
  cx({
    [className]: true,
    [`sl-conditions-color--${conditionClassModifier(conditions)}-background`]: true,
  });

interface Props {
  bar: RatingHour;
  barLength: number;
  index: number;
  nextConditions?: string;
}

const ConditionRatingsBar: React.FC<Props> = ({ barLength = 0, bar, index, nextConditions }) =>
  bar ? (
    <div
      key={`condition-ratings-bar-${index + 1}`}
      style={{
        width: `calc(${100 / barLength}%)`,
        backgroundClip:
          nextConditions && bar.rating !== nextConditions ? 'padding-box' : 'border-box',
      }}
      className={getConditionsClassName('bar', bar.rating || '')}
      data-testid="condition-ratings-bar"
    />
  ) : null;

export default React.memo(ConditionRatingsBar);
